import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../data/site";

const NAV_ITEMS = [
  { k: "home", p: "/" },
  { k: "terminal", p: "/terminal" },
  { k: "operations", p: "/operacoes" },
  { k: "infrastructure", p: "/infraestrutura" },
  { k: "cabotage", p: "/cabotagem" },
  { k: "group", p: "/grupo" },
  { k: "contact", p: "/contato" },
];

export const Header = () => {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkCls = ({ isActive }) =>
    `hover:text-white transition-colors ${isActive ? "text-ops-light" : ""}`;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-ops bg-ops-base/90 backdrop-blur-md"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-12 py-3">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <span className="bg-white rounded-lg px-2.5 py-1.5 inline-flex items-center">
            <img src={IMAGES.opsLogo} alt="Open Port Services" className="h-9 w-auto" />
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7 text-[11px] uppercase tracking-[0.18em] font-display font-medium text-ops-muted">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.k}
              to={item.p}
              end={item.p === "/"}
              data-testid={`nav-${item.k}`}
              className={linkCls}
            >
              {t.nav[item.k]}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div
            data-testid="lang-toggle"
            className="flex items-center rounded-full border border-ops overflow-hidden mono-tag text-[10px]"
          >
            <button
              data-testid="lang-pt"
              onClick={() => setLang("pt")}
              className={`px-3 py-1.5 transition-colors ${lang === "pt" ? "bg-ops-light text-ops-base font-bold" : "text-ops-muted hover:text-white"}`}
            >
              PT
            </button>
            <button
              data-testid="lang-en"
              onClick={() => setLang("en")}
              className={`px-3 py-1.5 transition-colors ${lang === "en" ? "bg-ops-light text-ops-base font-bold" : "text-ops-muted hover:text-white"}`}
            >
              EN
            </button>
          </div>

          <Link
            to="/contato"
            data-testid="header-cta"
            className="hidden md:inline-flex text-[11px] uppercase tracking-widest font-display font-bold px-5 py-2.5 bg-ops-light text-ops-base rounded hover:bg-white transition-colors"
          >
            {t.nav.cta}
          </Link>

          <button
            data-testid="mobile-menu-button"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-ops bg-ops-base px-6 py-6">
          <nav className="flex flex-col gap-4 text-sm uppercase tracking-[0.18em] font-display font-medium text-ops-muted">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.k}
                to={item.p}
                end={item.p === "/"}
                data-testid={`mobile-nav-${item.k}`}
                className={({ isActive }) => `hover:text-white transition-colors ${isActive || location.pathname === item.p ? "text-ops-light" : ""}`}
                onClick={() => setOpen(false)}
              >
                {t.nav[item.k]}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
